import SumoLogger from 'sumo-logger';
import uuid from 'uuid';
import Raygun from 'raygun4js';

if (process.env.NODE_ENV !== 'local') {
  Raygun('enableCrashReporting', true);
  Raygun('apiKey', '5SneNeE4m7QlE993NjUpQ');
}
const options = {
  endpoint: 'https://endpoint4.collection.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV23fQe2uchSM16FNJ7BftaXXZQv28bSL7svP755Pnp3RQaxW2f4CbOZZGpB8q_QW-a119Py4bstHpoibQKsl1MXriY9pi8o6lWKmLVHGc9UIA==',
  returnPromise: false,
  interval: 2000,
  batchSize: 100,
  sendErrors: true,
  sessionKey: uuid(),
  sourceName: 'Bestige-Client',
  sourceCategory: process.env.NODE_ENV,
  clientUrl: window.location.href,
};
const loggerInstance = new SumoLogger(options);
const windowConsole = window.console;

const sumoLogger = {
  log(text) {
    // Log to console.
    if (process.env.NODE_ENV === 'local') {
      windowConsole.log(text);
    }
  },
  debug(text) {
    // Local -> log to console,
    // Dev/Staging -> Log to sumo logic,
    // UAT and above -> Do not log.
    // eslint-disable-next-line default-case
    switch (process.env.NODE_ENV) {
      case 'local':
        windowConsole.debug(text);
        break;
      case 'development':
      case 'staging':
        loggerInstance.log(text);
        break;
    }
  },
  information(text) {
    // local -> log to console
    // other -> log to sumo logic.
    if (process.env.NODE_ENV === 'local') {
      windowConsole.info(text);
    } else {
      loggerInstance.log(text);
    }
  },
  error(text) {
    // local -> log to console
    // other -> log to sumo logic & raygun
    if (process.env.NODE_ENV === 'local') {
      windowConsole.error(text);
    } else {
      Raygun('send', text);
      loggerInstance.log(text);
    }
  },
};
export { sumoLogger as default };
